import { observer } from "mobx-react-lite";
import React, { useContext, useMemo } from "react";
import { Routes, Route } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import InfluencerStatusColumn from "./InfluencersParts/InfluencerStatusColumn";
import CampaignInfluencerSidebar from "./InfluencersParts/CampaignInfluencerSidebar";
import InfluencerMainHeader from "./InfluencersParts/InfluencerMainHeader";
import { SharedCampaignContext } from "../../../../contexts/Advertiser/SharedCampaignContext";
import { useSidebarCollapse } from "../../../../contexts/SidebarCollapseContext";

export default observer(function Influencers() {
  const { campaign } = useContext(SharedCampaignContext);
  const { isCollapsed } = useSidebarCollapse();

  const statuses = useMemo(
    () => campaign.statuses,
    [campaign.statuses, campaign.statuses.length],
  );

  return (
    <>
      <Routes>
        <Route
          path="campaign_authentications/:campaign_authentication_id/*"
          element={<CampaignInfluencerSidebar />}
        />
      </Routes>
      <InfluencerMainHeader />
      <div
        className={`flex flex-col pr-7 w-full overflow-x-auto dark:bg-rb-dark-mode-background transition-all duration-300 ${isCollapsed ? "pl-16" : "pl-56"}`}
      >
        <h2 className="text-lg font-bold shrink-0 pt-3 pl-6 dark:text-white">
          Influencer status
        </h2>
        <div className="flex items-start ml-6 gap-4 pb-2">
          <div className="flex justify-start" style={{ minHeight: "700px" }}>
            <DragDropContext>
              <Droppable
                droppableId="columns"
                direction="horizontal"
                type="column"
                isDropDisabled
              >
                {(provided) => (
                  <div
                    className="flex gap-x-5 pb-2 w-max"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    {statuses.map((status, index) => (
                      <Draggable
                        key={status.id}
                        draggableId={`column-${status.id}`}
                        index={index}
                        isDragDisabled
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                          >
                            <InfluencerStatusColumn
                              status={status}
                              dragHandleProps={provided.dragHandleProps}
                            />
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </div>
      </div>
    </>
  );
});
